<template>
    <component :is="tagName" class="loading-overlay-parent">
        <div v-if="active" class="loading-overlay u-flex u-flex--horizontal-align">
            <spinner :size="96" />
        </div>
        <slot />
    </component>
</template>

<script>
import Spinner from '@/components/ui/Spinner.vue'

export default {
    components: { Spinner },

    props: {
        tagName: { type: String, default: 'div' },
        active: { type: Boolean, required: true },
        text: { type: String, default: '' },
        spinnerColor: { type: String, default: 'primary', validator: val => [ 'primary', 'white' ].includes(val) },
    },
}
</script>

<style lang="scss" scoped>
.loading-overlay-parent {
    position: relative;
}

.loading-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: $index-loading-overlay;
    background-color: rgba($white, 0.7);
}
</style>
